import { Pipe, PipeTransform } from '@angular/core';
import { translate } from '@shared/utils/translate.utils';

const translations = {
  'SCHEDULED': $localize`Programmata`,
  'RESCHEDULED': $localize`Riprogrammata`,
  'IN_PROGRESS': $localize`In corso`,
  'COMPLETED': $localize`Completata`,
  'DELAYED': $localize`In ritardo`,
  'MISSED': $localize`Persa`,
  'NOT_COMPLETED': $localize`Non completata`,
  'SKIPPED': $localize`Saltata`,
  'DELETED': $localize`Cancellata`,
};

@Pipe({
  name: 'programStatus',
  standalone: true,
  pure: true,
})
export class EventStatusPipe implements PipeTransform {
  transform(value: string | Array<string>): string | Array<string> {
    return translate(value, translations);
  }
}
